import React, {useState, useEffect} from 'react';
import {RolesList} from '../common';
import RolesDescriptions from './rolesDescriptionsTooltip';
import axios from 'axios';
import './members.scss';

import {
	MembersCard as OneUxMembersCard,
} from 'shared-one-ux-components';
import {SdfButton, SdfAlert} from '@synerg/react-components';
import MembersCardShimmer from './memberCardShimmer';
import get from 'lodash/get';

export default function MembersCard({data, type, ...props}) {
	const [list, setList] = useState(data);
	const [userRole, setUserRole] = useState([]);
	/* eslint-disable no-unused-vars */
	// wording
	const {
		subtitle, action, partnerType = '', orgName, loggedInAoid, adminView,
	} = props;
	// data status
	const {fetch, error, isLoading} = props;
	// actions
	const {
		openAdd,
		openDetails,
		openEdit,
		openPasswordReset,
		openSuspend,
		openActivate,
		roleDescriptions = [],
	} = props;
	/* eslint-disable no-unused-vars */

	useEffect(() => {
		setList(data);
		/* eslint-disable-next-line */
	}, [data]);

	useEffect(() => {
		const getSession = async() => {
			const result = await axios(
					`${import.meta.env.VITE_ROOT_PATH}/api/session`);
			setUserRole(result.data.roles);
		};
		getSession();
	}, []);

	const sortables = ['memberName', 'memberUserName'];
	const keys = ['memberInitials', ...sortables];
	const titles = [null, 'NAME', 'USER NAME'];
	if (type === 'active') {
		keys.push('roles');
		titles.push('ROLE(S)');
	}
	/* eslint-disable no-unused-vars */
	const [infoCards, setInfoCards] = useState([
		{
			title: 'ROLE(S)',
			info: (
					<RolesDescriptions userRoles={userRole} partnerType={partnerType}/>),
		}]);
	const [ASC, DESC] = ['asc', 'desc'];
	const [sortBy, setSortBy] = useState(sortables[0]);
	const [sortOrder, setSortOrder] = useState(ASC);
	/* eslint-disable no-unused-vars */

	const sort = column => {
		if (!sortables.includes(column)) {
			return;
		}

		if (column !== sortBy) {
			setSortBy(column);
		}

		const sorted = list.sort((a, b) => {
			const sortables = [a[column], b[column]];
			const [left, right] = sortOrder === ASC ? sortables : sortables.reverse();
			return left.toLowerCase().localeCompare(right.toLowerCase());
		});

		setSortOrder(sortOrder === ASC ? DESC : ASC);
		setList(sorted);
	};

	const mappedMemberWithRoles = (data || []).map((member) => {
		const mappedRoles = get(member, 'roles', []).map((role) => {
			const item = RolesList.find(roleItem => roleItem.id === role.roleCode);
			const userStatus = get(member, 'status', 'Active');
			return {
				...role,
				roleName: item.name,
				order: item.order,
				styles: item.color && userStatus === 'Active'
						? {backgroundColor: item.color, marginRight: '4px'}
						: {backgroundColor: '#726c66', marginRight: '4px'},
				initials: item.shortName,
			};
		});

		mappedRoles.sort((roleA, roleB) => {
			if (roleA.order < roleB.order) {
				return -1;
			} else
				if (roleA.order > roleB.order) {
					return 1;
				} else {
					return 0;
				}
		});

		return {
			...member, data: {
				...member, userId: member.userName, roles: mappedRoles,
			},
		};
	});

	return (<div className={`members-card ${type}`}>
		<div>
			<div className={`flex justify-between flex-wrap gap-4 ${ adminView ? 'mb-8' : 'mb-6'}`} style={{width: '880px', maxWidth:'100%'}}>
				<div>
					<h1 className={`text-heading-05 ${adminView ? 'mt-8 mb-2' : 'mt-6 mb-0'}`}>Members
						of {orgName} ({(mappedMemberWithRoles || []).length})</h1>
					{adminView &&
					<div className="text-body-02">Manage the partner’s team members’
						access to this application only.</div>}
				</div>
				<SdfButton className={adminView ? 'mt-6' :'mt-4'} action="standard" emphasis="primary" size="sm"
				           variant="contained" onClick={openAdd} style={{whiteSpace: 'nowrap'}}>Add team member
				</SdfButton>
			</div>
		</div>
		{data && !error && !isLoading && <div>
			{(mappedMemberWithRoles || []).map((member, index) => {
				const {data} = member;
				return <OneUxMembersCard
						containerClasses={'flex pb-4'}
						showMenuOptions={true}
						key={index}
						index={((mappedMemberWithRoles || []).length - index)}
						memberData={{
							...data,
							memberType: 'external',
							aoid: data.associateOID,
							userStatus: data.status,
						}}
						isSuspended={member.isSuspended}
						fetchMembers={() => {}}
						setToastData={() => {}}
						onOpenEdit={openEdit}
						aoid={loggedInAoid}
						onOpenResetPassword={openPasswordReset}
						onOpenSuspendMember={openSuspend}
						onOpenActivateMember={openActivate}
						isAllowedToEdit={false}
						isAdmin={false}
						clientOOID={''}
						disabledEditRoles={(loggedInAoid === data.associateOID ||
								data.status !== 'Active') ? 'true' : undefined}
				></OneUxMembersCard>;
			})}
		</div>}
		{isLoading && !error && <div className={'flex flex-col gap-4'}>
			<MembersCardShimmer/>
			<MembersCardShimmer/>
		</div>}
		{error && <div>
			<SdfAlert type="banner" status="error" size="sm" icon="alert-error">
				Error occurred while trying to fetch members
				<span slot="action">
					<SdfButton
							onClick={fetch}
							empahsis="primary">
						Try Again
					</SdfButton>
				</span>
			</SdfAlert>
		</div>}
	</div>);
}
